/* eslint-disable no-useless-rename */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useMemo, useRef, useState} from 'react'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'

//components
// import WSButton from '_metronic/helpers/components/WSButton/WSButton'

//conatants

//css
import './QuickMessage.scss'
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

import {useLocation} from 'react-router-dom'

import Select, {MenuListProps, components} from 'react-select'
///////////////working/////////////

import {Form, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import React from 'react'
import CreatableSelect from 'react-select/creatable'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import MessageBoxV2 from '../../../../Components/MessageBoxV2'
import moment from 'moment-timezone'
import { getDefaultOptOutUrl } from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'

export const initialData = {
  camp_type: 'sms',
  sender: '',
  contacts: [],
  subject: '',
  media: '',
  message: '',
  optout: false,
  alphaId: '',
  gif: '',
  longUrl: [],
  replyStopToOptOut: true,
  senderType: '',
}

const SendMessagePopup = ({
  valid,
  setValid,
  show,
  handleClose,
  contacts,
  CustomReplyReport,
  setCustomReplyReport = () => {},
}: any) => {
  const dispatch = useDispatch()
  const param: any = useLocation()
  const optOutBaseUrl = useSelector(getDefaultOptOutUrl)


  ////////////////////////////////////////////////////////////////USE SELECTOR//////////////////////
  const quickmsg = useSelector((state: any) => state?.quickMsg?.QuickMsg)
  const isAdmin = localStorage.getItem('isAdmin')

  /////////////////////////////////USE STATE/////////////////
  const [templateNameModel, setTemplateNameModel] = useState(false)
  const [quickSms, setQuickSms] = useState(true)
  const [success, setSuccess] = useState(false)
  const [preview, setPreview] = useState(false)

  const [sendData, setSendData] = useState<any>({
    camp_type: 'sms',
    sender: '',
    contacts: [],
    subject: '',
    media: '',
    message: '',
    optout: false,
    alphaId: '',
    gif: '',
    longUrl: [],
    replyStopToOptOut: true,
    senderType: '',
  })

  const [error, setError] = useState<any>({})

  const [options, setOptions] = useState({
    webLink: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    customLanding: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    optOut: [
      {value: "Reply 'Stop' to opt-out ", label: 'Reply Stop'},
      {value: 'STOP:{stoptxt.cc/}', label: 'custom survey'},
    ],
  })

  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={async () => {
          handleClose()
        }}
        className={`quickMessageModal ${show ? 'right' : 'left'} `}
        dialogClassName={`modal-dialog-centered mw-900px nopreviweQuickMessage`}
      >
        <div className='card w-100 rounded-0' id='kt_drawer_chat_messenger'>
          <div
            className='card-header pe-5 quick-message-header'
            id='kt_drawer_chat_messenger_header'
          >
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <a
                  href='#'
                  className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1 d-flex align-items-center gap-2 '
                  style={{textDecoration: 'none'}}
                >
                  <img src='/media/svg/automation/messages.svg' alt='icon' />
                  Send message #1
                </a>
              </div>
            </div>

            <div className='card-toolbar'>
              <div
                className='btn btn-sm btn-icon btn-active-light-primary'
                id='kt_drawer_chat_close'
                onClick={handleClose}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
              </div>
            </div>
          </div>

          <form className='form quick-message-form' noValidate>
            <div className='card-body '>
              <div className='d-flex'>
                <div className='d-flex'>
                  <div className='QuickMsgLeft'>
                    <div className='row mb-2' data-kt-buttons='true'>
                      <MessageBoxV2
                        setError={setError}
                        error={error}
                        setUserMessage={setSendData}
                        userMessage={sendData}
                        options={options}
                        quickSms={quickSms}
                        showSelect={['template', 'customfield', 'weblink', 'opt-out']}
                        itQuickMessage={true}
                      />
                      <span className='text-danger mb-2'>{error?.message}</span>

                      <div className=''>
                        <div className='d-flex flex-start'>
                          <button
                            id={success === true ? 'kt_drawer_chat_close' : ''}
                            type='submit'
                            // disabled={data}
                            className='btn btn-sm btn-primary me-2 p-3 px-5 fw-500 me-2'
                          >
                            <span className='indicator-label'>Update</span>
                          </button>
                          <div
                            id='kt_drawer_chat_close '
                            style={{
                              visibility: 'hidden',
                            }}
                          >
                            <button
                              className='btn btn-sm fw-600 p-3 px-5 gray_bg_purple'
                              type='button'
                              onClickCapture={() => {
                                if (sendData.message != '') setTemplateNameModel(true)
                              }}
                            >
                              Save as template
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='QuickmsgPreview'>
                    <div className='newmessage_right newmessage_right_mobile'>
                      <nav>
                        <div className='nav nav-tabs' id='nav-tab' role='tablist'>
                          <button
                            className='nav-link active'
                            id='nav-home-tab'
                            data-bs-toggle='tab'
                            data-bs-target='#nav-home-quick'
                            type='button'
                            role='tab'
                            aria-controls='nav-home'
                            aria-selected='true'
                          >
                            {/* <i className='bi bi-unlock'></i> */}
                            <KTSVG path='/media/mobile/Mobile-Unlock.svg' className='svg-icon-2' />
                          </button>
                          <button
                            className='nav-link'
                            id='nav-profile-tab'
                            data-bs-toggle='tab'
                            data-bs-target='#nav-profile-quick'
                            type='button'
                            role='tab'
                            aria-controls='nav-profile-quick'
                            aria-selected='false'
                          >
                            {/* <i className='bi bi-lock'></i> */}
                            <KTSVG path='/media/mobile/Mobile-Lock.svg' className='svg-icon-2' />
                          </button>
                        </div>
                      </nav>
                      <div className='tab-content' id='nav-tabContent'>
                        <div
                          className='tab-pane fade show active'
                          id='nav-home-quick'
                          role='tabpanel'
                          aria-labelledby='nav-home-tab'
                        >
                          <div
                            className='tab-pane fade show active'
                            id='nav-home-quick'
                            role='tabpanel'
                            aria-labelledby='nav-home-tab'
                          >
                            <div
                              className='mobile-bg-wrapper grey-bg new_mobile'
                              style={{
                                backgroundImage: `url(${toAbsoluteUrl(
                                  '/media/mobile/NewMobile.png'
                                )})`,
                              }}
                            >
                              <div className='mobile-inner'>
                                <div className='mobile-head'>
                                  <strong className='msg-mobile-title p-6 d-block text-center px-12'>
                                    <KTSVG
                                      className='svg-icon-8'
                                      path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                                    />{' '}
                                    {sendData?.sender}
                                  </strong>
                                </div>
                                <div className='mobile-body'>
                                  <div className='message-box'>
                                    <div className='time text-center'>
                                      Today {moment().format('LT')}
                                    </div>
                                    {!quickSms && sendData.subject !== '' && (
                                      <div
                                        className='message fw-bolder
                                      '
                                      >
                                        {sendData.subject}
                                      </div>
                                    )}
                                    {/* 
                                    {sendData?.media !== '' && sendData?.media !== undefined && (
                                      <span>
                                        {typeof sendData?.media == 'string' ? (
                                          <img src={sendData?.media} alt='poster' />
                                        ) : (
                                          <>
                                            {sendData?.media?.type
                                              ?.split('/')
                                              ?.includes('video') ? (
                                              <video
                                                src={URL.createObjectURL(sendData?.media)}
                                                width={300}
                                                height={100}
                                                controls
                                              />
                                            ) : (
                                              <img
                                                src={URL.createObjectURL(sendData?.media)}
                                                alt='poster'
                                              />
                                            )}
                                          </>
                                        )}
                                      </span>
                                    )} */}
                                    {!quickSms &&
                                      sendData?.media !== '' &&
                                      sendData?.media !== undefined && (
                                        <>
                                          {typeof sendData?.media == 'string' && (
                                            <span>
                                              {!sendData?.mediaType
                                                ?.split('/')
                                                ?.includes('video') ? (
                                                <img
                                                  src={sendData?.media}
                                                  alt='poster'
                                                  className='rounded-3 mb-2'
                                                />
                                              ) : (
                                                <video
                                                  src={sendData?.media}
                                                  width={300}
                                                  height={100}
                                                  controls
                                                />
                                              )}
                                            </span>
                                          )}
                                          {typeof sendData?.media !== 'string' && (
                                            <span>
                                              {!sendData?.media?.type
                                                ?.split('/')
                                                ?.includes('video') ? (
                                                <img
                                                  src={URL.createObjectURL(sendData?.media)}
                                                  alt='poster'
                                                  className='rounded-3 mb-2'
                                                />
                                              ) : (
                                                <video
                                                  src={URL.createObjectURL(sendData?.media)}
                                                  width={300}
                                                  height={100}
                                                  controls
                                                />
                                              )}
                                            </span>
                                          )}
                                        </>
                                      )}
                                    {!quickSms &&
                                      sendData?.gif !== '' &&
                                      sendData?.gif !== undefined && (
                                        <span>
                                          <img
                                            src={sendData?.gif}
                                            alt='poster'
                                            className='rounded-3 mb-2'
                                          />
                                        </span>
                                      )}

                                    {sendData.message !== '' && (
                                      <div className='message'>
                                        <pre>{`${sendData?.message}`}</pre>
                                        <br />
                                        <br />
                                        <span>{`${
                                          sendData?.optout !== true
                                            ? "Reply 'STOP' to opt-out"
                                            : `STOP:{${optOutBaseUrl}/${sendData?.optoutLabel ?? ''}}`
                                        }`}</span>
                                      </div>
                                    )}
                                  </div>
                                  <div className='send-msg'>
                                    <input type='text' />
                                    <a
                                      href='#'
                                      className='send_btn'
                                      style={{
                                        backgroundImage: `url(${toAbsoluteUrl(
                                          '/media/mobile/send.svg'
                                        )})`,
                                      }}
                                    ></a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className='tab-pane fade'
                          id='nav-profile-quick'
                          role='tabpanel'
                          aria-labelledby='nav-profile-tab'
                        >
                          <div
                            className='mobile-bg-wrapper grey-bg'
                            style={{
                              backgroundImage: `url(${toAbsoluteUrl(
                                '/media/mobile/unlock-screen.svg'
                              )})`,
                            }}
                          >
                            <div className='unlock-screen-content'>
                              <div className='notification-outer'>
                                <div className='Notification-item'>
                                  <div className='user-icon'>
                                    <img
                                      alt='Logo'
                                      src={toAbsoluteUrl(
                                        '/media/mobile/user-icon-notification.png'
                                      )}
                                    />
                                  </div>
                                  <div className='notification-data'>
                                    <label htmlFor=''>
                                      &#x2329;{' '}
                                      {sendData?.sender === '#SharedNum#'
                                        ? '#SharedNum#'
                                        : sendData?.sender}
                                      &#12297;
                                    </label>
                                    <p>{sendData?.message}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default SendMessagePopup
